<template>
    <div>
      <div class="row">
        <div class="col-md-12 d-none d-sm-block" v-if="salarySpecification"> 
            <div class="float-right mb-1">
                <b-button variant="primary" class="mr-1" v-on:click="edit()" :disabled="salarySpecification.isLocked || creatingPdf || locking || updating || attesting" v-if="loginState.isAdministrator && !salarySpecification.isAttested && !salarySpecification.isDeprecated" >
                    <i class="icon-note icons mr-1"/>{{!editMode ? 'Editera' : 'Avsluta editering'}}
                </b-button>
                <b-button variant="primary" class="mr-1" v-on:click="update()" :disabled="!salarySpecification || salarySpecification.isLocked || creatingPdf || locking || updating || attesting || editMode" v-if="loginState.isAdministrator && !salarySpecification.isAttested && !salarySpecification.isDeprecated" >
                    <i class="icon-reload icons mr-1" v-if="!updating" /><b-spinner v-if="updating" class="mr-1" type="border" small />{{!updating ? 'Uppdatera' : 'Uppdaterar'}}
                </b-button>
                <b-button variant="primary" class="mr-1" v-on:click="locktoggle()" :disabled="creatingPdf || locking || updating || attesting || editMode" v-if="loginState.isAdministrator && !salarySpecification.isAttested && !salarySpecification.isDeprecated" >
                    <i class="icon-lock icons mr-1" v-if="!salarySpecification.isLocked"/><i class="icon-lock-open icons mr-1" v-if="salarySpecification.isLocked"/>{{lockButtonText}}
                </b-button>                   
                <b-button variant="primary" class="mr-1" v-on:click="attest()" :disabled="!isCurrentDate || salarySpecification.isLocked || creatingPdf || locking || updating || attesting || editMode" v-if="loginState.isAdministrator && !salarySpecification.isAttested && !salarySpecification.isDeprecated" >
                    <i class="icon-check icons mr-1" v-if="!attesting"/><b-spinner v-if="attesting" class="mr-1" type="border" small />{{!attesting ? 'Attestera' : 'Attesterar'}}
                </b-button>
                <b-button variant="primary" v-on:click="createPdf()" :disabled="salarySpecification.isLocked || creatingPdf || locking || updating || attesting || editMode" >
                    <i class="fa fa-file-pdf-o mr-1" v-if="!creatingPdf"/><b-spinner v-if="creatingPdf" class="mr-1" type="border" small />{{!creatingPdf ? 'Ladda ner PDF' : 'Skapar PDF'}}
                </b-button>                
                </div>         
            </div>
        </div>        
        <b-card v-if="salarySpecification">
            <div slot="header">Lönespecfikation för {{salarySpecification.user.firstName}} {{salarySpecification.user.lastName}} <b-badge variant="success" v-if="salarySpecification.isAttested">Attesterad</b-badge>
                <b-badge variant="danger" v-if="salarySpecification.isDeprecated">Deprekerad</b-badge><b-badge variant="warning" v-if="salarySpecification.isLocked">Låst</b-badge>
                <div class="card-header-actions">
        
                </div>
            </div>
            <Validations :validations="salarySpecification.validations"/>
            <UserInformation :salarySpecification="salarySpecification"/>
            <SalaryRows :salarySpecification="salarySpecification" :editMode="editMode" @onSalaryRowUpdated="onSalaryRowUpdated" @onLoading="onLoading"/>
            <CalculationSummary :salarySpecification="salarySpecification"/>

            <b-card> 
                <div class="row">
                    <div class="col">
                        <strong>Utbetalas {{salarySpecification.paymentDate | moment("YYYY-MM-DD")}}</strong>
                    </div>
                    <div class="col text-right">
                        <strong>{{salarySpecification.netSalary | currency}}</strong>
                    </div>
                </div>
            </b-card>
        </b-card>

    </div>
</template>

<script>
import { salarySpecificationService } from "../../shared/services";
import Validations from './components/Validations'
import UserInformation from './components/UserInformation'
import SalaryRows from './components/SalaryRows'
import CalculationSummary from './components/CalculationSummary'
import { fail } from 'assert';
export default {
    components: {
        Validations,
        UserInformation,
        SalaryRows,
        CalculationSummary
    },
    computed: {
        lockButtonText() {
            if(!this.salarySpecification.isLocked) {
                if(this.locking) return "Låser";
                return "Lås";
            }

            if(this.locking) return "Låser upp";
            return "Lås upp";
        },
        isCurrentDate() {
            if(!this.salarySpecification) return false;
            var now = this.$moment();
            var moment = this.$moment(this.salarySpecification.paymentDate);
            return moment.year() == now.year() && moment.month() == now.month();
        }
    },
    methods: {
        loadSalarySpecification(salarySpecificationId) {
            this.loading = true;
            salarySpecificationService.getById(salarySpecificationId).then(p => {
                this.salarySpecification = p;
                this.loading = false;
            }).catch(() => {
                this.loading = false;
                this.ShowToast("Fel", "Ett okänt fel uppstod då lönespecifikationen skulle hämtas", "danger")
                });
        },
        edit() {
            this.editMode = !this.editMode;
        }, 
        update() {
            this.loading = true;
            this.updating = true;
            var oldId = this.salarySpecification.id;
            salarySpecificationService.update(this.salarySpecification.id).then(p => {
                if(p.id === oldId) {
                    this.ShowToast("Oförändrad", "Lönespecifikationen oförändrad", "success");
                } else {
                    this.ShowToast("Uppdaterad", "Lönespecifikationen uppdaterad", "success");
                }
                this.loading = false;
                this.updating = false;
                this.salarySpecification = p;
                this.$router.push({ path: `${p.id}` });     
            }).catch(() =>  {
                this.ShowToast("Fel", "Ett okänt fel uppstod då lönespecifikationen skulle uppdateras", "danger")
                this.loading = false;
                this.updating = false;
            });
        },
        attest() {
            this.$bvModal.msgBoxConfirm(`Är du säker på att du vill attestera lönespecifikation '${this.salarySpecification.id}'?`)
            .then(value => {
                if(!value) return;
                this.attesting = true;
                this.loading = true;
                salarySpecificationService.attest(this.salarySpecification.id).then(p => {
                    this.ShowToast("Attesterad", "Lönespecifikationen attesterad", "success");
                    this.loading = false;
                    this.attesting = false;
                    this.salarySpecification = p;
                    this.$router.push({ path: `${p.id}` });    
                }).catch(() => {
                    this.ShowToast("Fel", "Ett okänt fel vid fråga om attest uppstod", "danger");
                    this.loading = false;
                    this.attesting = false;
                });
            }).catch(() => { 
                this.ShowToast("Fel", "Ett okänt fel uppstod då lönespecifikationen skulle attesteras", "danger");
            });
        },
        locktoggle() {
            this.locking = true;
            this.loading = true;
            salarySpecificationService.lockToggle(this.salarySpecification.id, !this.salarySpecification.isLocked).then(() => {
                if(!this.salarySpecification.isLocked) {
                    this.salarySpecification.isLocked = true;
                    this.ShowToast("Låst", "Lönespecifikationen låst", "success");
                } else {
                    this.salarySpecification.isLocked = false;
                    this.ShowToast("Upplåst", "Lönespecifikationen upplåst", "success");                    
                }

                this.locking = false;
                this.loading = false;
            }).catch(() =>  {
                this.ShowToast("Fel", "Ett okänt fel uppstod då lönespecifikationen skulle låsas", "danger")
                this.locking = false;
                this.loading = false;
            });
        },
        createPdf() {
            this.creatingPdf = true;
            this.loading = true;
            salarySpecificationService.getPdf(this.salarySpecification).then(() => {
                this.creatingPdf = false;
                this.loading = false;
            })
        },     
        onSalaryRowUpdated(salarySpecification) {
            this.salarySpecification = salarySpecification;
            this.$router.push({ path: `${salarySpecification.id}` });
        },
        onLoading(loading) {
            this.loading = loading;
        },
    },

    data() {
        return {
            loading: false,
            salarySpecification: null,
            attesting: false,
            editMode: false,
            updating: false,
            locking: false,
            creatingPdf: false,
            isAttested: false,
        }
    },
    created() {
        this.loadSalarySpecification(this.$route.params.id);
    },
}
</script>

<style ang="css">
    .card .no-radius {
        border-radius: 0% ;
    } 
</style>
